export default {"src":"/_next/static/media/alstone_logo.b6fd4abc.svg","height":300,"width":300,"blurWidth":0,"blurHeight":0};